import React from 'react'
import propTypes from 'prop-types'
import { Button, Typography } from '@material-ui/core'

import { DialogView } from '../../common/Dialog'

export const REMOVE_DIALOG_TITLE = 'Remove substitute material'

/**
 * Names the record about to be removed, so the user can check it is the one they meant.
 * @param {*} item
 */
export const getRemoveConfirmationText = (item) => {
	if (!item || !item.ObsoleteMaterialCode) {
		return 'This relation will be removed from the catalog. This action cannot be undone.'
	}
	let label = item.ObsoleteMaterialDescription
		? `${item.ObsoleteMaterialCode} | ${item.ObsoleteMaterialDescription}`
		: `${item.ObsoleteMaterialCode}`
	return `The relation for discontinued material ${label} will be removed from the catalog. This action cannot be undone.`
}

/**
 * Confirmation for removing one relation.
 *
 * The removal is definitive — the catalog has no active/inactive state — which is why the text
 * says so rather than leaving the user to assume it is reversible.
 */
const RemoveSubstituteMaterialDialog = (props) => {
	const { open, onClose, onConfirm, isSaving, item } = props

	return (
		<DialogView
			open={open}
			onClose={onClose}
			disabled={isSaving}
			isSaving={isSaving}
			header={REMOVE_DIALOG_TITLE}
			maxWidth='sm'
			actions={
				<>
					<Button onClick={onClose} disabled={isSaving}>
						Cancel
					</Button>
					<Button onClick={onConfirm} variant='outlined' color='secondary' disabled={isSaving}>
						Remove
					</Button>
				</>
			}
		>
			<Typography variant='body2'>{getRemoveConfirmationText(item)}</Typography>
		</DialogView>
	)
}

RemoveSubstituteMaterialDialog.propTypes = {
	open: propTypes.bool.isRequired,
	onClose: propTypes.func.isRequired,
	onConfirm: propTypes.func.isRequired,
	isSaving: propTypes.bool,
	/**Record about to be removed */
	item: propTypes.object
}

RemoveSubstituteMaterialDialog.defaultProps = {
	open: false,
	isSaving: false,
	item: null,
	onClose: () => console.warn('Callback [onClose] no defined'),
	onConfirm: () => console.warn('Callback [onConfirm] no defined')
}

export default RemoveSubstituteMaterialDialog
